<template>
  <div id="misc">
    <v-select
      v-model="$i18n.locale"
      :items="locales"
      item-text="label"
      item-value="code"
      label="Language"
      outlined
      dense
      class="mb-4"
      style="position : absolute ; top : 10px ; right : 10px"
    />
    <img class="misc-mask" height="226"
      :src="require(`@/assets/images/misc/misc-mask-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)" />


    <div class="page-title text-center px-5">
      
      <img
        src="https://devmyway.azeemtechs.com/img/Icon-Blue.png"
        alt="Logo"
        class="mx-auto mb-6"
        style="max-height: 100px;"
      />


      <h2 class="text-2xl font-weight-semibold text--primary d-flex align-center justify-center">
        <span class="me-2">{{ $t('title') }} {{ systemName }}</span>
      </h2>
      <div v-if="!isUserLoggedIn" class="my-6">
        <div class="flex flex-wrap gap-4 mb-6">
          <v-btn style="margin:5px" color="primary" to="/login">
            {{ $t('admin_login') }}
          </v-btn>
          <v-btn style="margin:5px" color="primary" to="/login">
            {{ $t('school_login') }}
          </v-btn>
          <v-btn style="margin:5px" color="primary" to="/login">
            {{ $t('facility_login') }}
          </v-btn>
        </div>

        <div class="flex flex-wrap gap-4">
          <v-btn style="margin:5px" color="primary" to="/school-register">
            {{ $t('school_signup') }}
          </v-btn>
          <v-btn style="margin:5px" color="primary" to="/register">
            {{ $t('facility_signup') }}
          </v-btn>
        </div>
      </div>

      <div v-else class="my-6">
        <v-btn color="primary" :to="dashboardPath" class="mb-4 mr-4">
          {{ $t('dashboard') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mdiAlert } from '@mdi/js'
import { Keys } from '/src/config.js'
import auth from '@/services/AuthService'
export default {
  components: {
    Keys
  },
  setup() {
    return {
      icons: {
        mdiAlert,
      },
      systemName: Keys.VUE_APP_SYSTEM_NAME
    }
  },
  data() {
    return {
      isUserLoggedIn: false,
      userRole: null,
      locales: [
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' }
      ]
    }
  },
  mounted() {
    this.isUserLoggedIn = auth.isUserLoggedIn()
    this.userRole = auth.getLoggedInUserRole()
  },
  computed: {
    dashboardPath() {
      switch (this.userRole) {
        case 'admin':
          return '/admin-dashboard';
        case 'school':
          return '/school-dashboard';
        default:
          return '/';
      }
    }
  }

}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/misc.scss';
</style>
